if (!customElements.get('simple-video')) {
    class SimpleVideo extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('[data-play]');
        this.video = this.querySelector('[data-video]');
        this.poster = this.querySelector('.video-grid__poster');
  
        // Initialize event listeners
        this.init();
      }
  
      // Initialize event listeners
      init() {
        if (this.content) {
          this.content.addEventListener('click', this.handleContentClick.bind(this));
        }
        if (this.video && this.video.tagName === 'VIDEO') {
          this.video.disablePictureInPicture = true;
          this.video.setAttribute('disablepictureinpicture', '');
          if (this.video.controlsList && typeof this.video.controlsList.add === 'function') {
            this.video.controlsList.add('nopictureinpicture', 'noremoteplayback', 'nodownload');
          }
          this.video.addEventListener('play', this.handleVideoPlay.bind(this));
        }
      }

      stopPlayback() {
        if (this.video && this.video.tagName === 'VIDEO') {
          this.video.pause();
        }
      }

      handleVideoPlay() {
        document.querySelectorAll('simple-video').forEach((videoItem) => {
          if (videoItem !== this && typeof videoItem.stopPlayback === 'function') {
            videoItem.stopPlayback();
          }
        });
      }
  
      // Handle content click
      handleContentClick() {
        // Set data-hide attribute
        this.content.setAttribute('data-hide', '');
        if (this.poster) {
          this.poster.setAttribute('data-hide', '');
        }
  
        // Play the video
        if (this.video && this.video.tagName === 'VIDEO') {
          this.video.setAttribute('playsinline', '');
          this.video.setAttribute('webkit-playsinline', '');
          this.video.play();
        }
      }
    }
  
    customElements.define('simple-video', SimpleVideo);
  }
  